var common = require("../../../utiles/common.js");

function isNetWork(callback){
    var i = new Image();
    console.log(i);
    i.src = 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo_top_ca79a146.png?t=' + Date.parse(new Date());
    i.onload = function() {
        callback(1);
    };
    i.onerror = function() {
        callback(0);
    };
}
module.exports = {
    register: function () {
        document.createElement('tab-login')
        ko.components.register('tab-login', {
            viewModel: function (params) {
                var $this = this;
                common.refreshNode();//刷新node
                $this.loading = ko.observable(false);
                $this.loginTemplate = ko.observable('');
                isNetWork(function (work) {
                    localStorage.setItem("network",work);
                    $this.loading(true);
                    var template = localStorage.getItem("loginTemplate") == undefined?"default":localStorage.getItem("loginTemplate");
                    $this.loginTemplate(template);
                });
            },
            template: require("./TabLogin.html")
        });
        document.createElement('default-login')
        ko.components.register('default-login', {
            viewModel: function (params) {
                var $this = this;
                
            },
            template: require("../template/DefaultLogin.html")
        });
        document.createElement('concise-login')
        ko.components.register('concise-login', {
            viewModel: function (params) {
                var $this = this;
                
            },
            template: require("../conciseTemplate/ConciseLogin.html")
        });
        document.createElement('small-concise-login')
        ko.components.register('small-concise-login', {
            viewModel: function (params) {
                var $this = this;
                
            },
            template: require("../smallConcise/SmallConcise.html")
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/component/login/tabLogin/TabLogin.js
// module id = 111
// module chunks = 0